import {RootState} from '@/store'
import {actions} from "@/store/modules/customerService/actions";
import {getters} from "@/store/modules/customerService/getters";
import {mutations} from "@/store/modules/customerService/mutations";
import {Module} from 'vuex'


export interface MemberCRMDetails {
  accountsList: any[];
  fundTypeList: any[];
  address: string;
  email: string;
  fullName: string;
  mobilePhoneNumber: string;
  personalId: string;
  phoneNumber: string;
  gender: string;
  dateOfBirth: string;
  age:number;
  isDeath: boolean
}

export interface EmployerCRMDetails {
  employerId: number
  address: string;
  email: string;
  employerName: string;
  hpNumber: string;
  mobilePhoneNumber: string;
  phoneNumber: string;
}

export interface TabsConfiguration {
  generalDetailsFlag: boolean;
  accountDetailsFlag: boolean;
  customerServiceFlag: boolean;
  accountTransactionsFlag: boolean;
  transfersWithdrawalsFlag: boolean;
  beneficiariesFlag: boolean;
  securitiesFlag: boolean;
  employeeListForEmployerFlag: boolean;
  depositsForEmployerFlag: boolean;
  archiveDocumentsFlag: boolean;
  processStatusFlag: boolean;
  loansFlag: boolean;
}


export interface CustomerServiceState extends BaseState {
  referralStatusLobbySelection: string
}

export const initialState = function (): CustomerServiceState {
  return {
    isEmpty: true,
    referralStatusLobbySelection: ""
  }
}

export const customerService: Module<CustomerServiceState, RootState> = {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations
}